import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/** Dev-only: add `?previewRecovery=1` to the hash URL to preview the recovery screen. */
function isRecoveryPreviewEnabled(): boolean {
  if (!import.meta.env.DEV) return false;
  return window.location.hash.includes('previewRecovery=1');
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError || isRecoveryPreviewEnabled()) {
      return (
        <div className="tms-app-recovery">
          <div className="tms-app-recovery-card">
            <div className="tms-app-recovery-icon" aria-hidden>
              <ReloadOutlined />
            </div>
            <h1 className="tms-app-recovery-title">Please refresh the page</h1>
            <p className="tms-app-recovery-subtitle">
              The page was idle for a while. A quick refresh will continue your work.
            </p>
            <Button
              type="primary"
              className="brand-btn tms-app-recovery-btn"
              onClick={() => window.location.reload()}
            >
              Refresh Page
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
